<template>
    <div class="curve_chart">
        <img v-if="noData" class="noDataImg mt28" src="../../assets/img/company/noData.svg" alt="">
        <section>
            <p v-if="hasLine" class="homeComTitle hasLine">
                <span class="titleLine"></span>
                <span v-html="title"></span>
            </p>
            <div v-else class="homeComTitle" :class="[ imgClass ]">{{ title }}
                <span v-if="controlTitle" class="fs14 co_666 font_n float_r"
                      @click="$emit('checkDetail')">{{ controlTitle }}</span>
            </div>

            <div class="content fs14" v-html="content"></div>
            <div class="chartBox" :id='chartId'></div>
        </section>
    </div>
</template>

<script>
import moment from 'moment'
import _co from "@/util/const";
const echarts = require('echarts');

export default {
    name: "curveChart",
    components: {},
    props: {
        title: {
            type: String,
            default: '舆情健康指数趋势'
        },
        imgClass: {
            type: String,
            default: 'chartIcon'
        },
        renderData: Object,
        chartId: {
            type: String,
            default: "healthDate"
        },
        entity: {
            type: String,
            default: "金融业"
        },
        labelData: Array,
        content: {
            type: String,
            default: ""
        },
        controlTitle: String,
        periodStr: String,
        hasLine: Boolean,
    },
    data() {
        return {
            chart: null,
            noData: false,
            reportPeriodMap: _co.reportPeriodMap,
        }
    },
    mounted() {

        this.renderFunc()
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    watch: {
        "entity": function (pre, cur) {
            if (pre && cur)
                this.renderFunc()
        }
    },
    methods: {
        renderFunc() {
            let {target1, target2, labelData = []} = this.renderData;
            if ((!target1 || target1.length < 1) || (!target2 || target2.length < 1)) {
                this.noData = true
                return
            }
            this.noData = false
            let target2Arr = [], target2Len = 0,
                xAxis = target1.map(item => this.periodStr  != this.reportPeriodMap["year"] ? moment(item.date).format("MM/DD"):  moment(item.date).format("MM")),
                target1Arr = target1.length > 0 ? target1.map(item => item.value) : [],
                target1Len = target1Arr.length,
                todayDate = xAxis[target1Len - 1] || '';

            // 计算平均值时
            if (target2) {
                target2Arr = target2.length > 0 ? target2.map(item => item.value) : [];
                target2Len = target2Arr.length;
            }

            // 调整曲线右边两个点的数字的位置
            let data1LastOne = target1Arr[target1Len - 1]
            let data2LastOne = target2Arr[target2Len - 1];
            let data1Position = [10, -2];
            let data2Position = [10, -2];
            let gap = data1LastOne - data2LastOne;
            if(gap >= 0 && gap <= 5) {
              data1Position = [10, -(7 - gap)];
              data2Position = [10, 5 - gap];
            } else if(gap <= 0 && gap >= -5) {
              data1Position = [10, 5 - gap];
              data2Position = [10, -(7 - gap)];
            }

            let colorData = ["#03399f", "#5F88CF"];

            this.chart = echarts.init(document.getElementById(this.chartId));
            let option = {
                grid: {
                    top: '20%',
                    left: '2%',
                    right: '4.5%',
                    bottom: '2%',
                    containLabel: true,
                },
                legend: {
                    data: labelData,
                    right: 0,
                    itemWidth: 6,
                    icon: 'circle',
                    textStyle: {
                        color: colorData,
                        fontSize: 11,
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xAxis,
                    axisLine: { //  改变x轴颜色
                        lineStyle: {
                            type: [5, 10],
                            dashOffset: 5,
                            color: '#C9C9CA',
                        }
                    },
                    axisLabel: { //  改变x轴字体颜色和大小
                        textStyle: {
                            color: "#000000",
                            fontSize: 11
                        },
                        interval: xAxis.length > 25 ? 5: (xAxis.length > 10 ? 3 : 0),
                        showMinLabel: true,
                        showMaxLabel: true,

                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false,
                    }
                },
                yAxis: {
                    type: 'value',
                    name: '健康指数(分)',
                    min: 0,
                    max: 100,
                    nameTextStyle: {
                        color: '#666666',
                        fontWeight: 'bold',
                        fontSize: 10
                    },
                    axisLine: { //  改变y轴颜色
                        show: false,
                    },
                    axisLabel: { //  改变y轴字体颜色和大小
                        //formatter: '{value} m³ ', //  给y轴添加单位
                        textStyle: {
                            color: "#000000",
                            fontSize: 10
                        },
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['#C9C9CA'],
                            fontSize: 10,
                            width: 1,
                            type: 'dotted'
                        }
                    }
                },
                series: [{
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    name: labelData[0],
                    markPoint: {
                        symbol: "circle",
                        symbolSize: 6,
                        itemStyle: {
                            color: '#ffffff',
                            borderWidth: 1,
                        },
                        data: [
                            {
                                value: target1Arr[target1Len - 1],
                                label: {
                                    position: data1Position,
                                    color: colorData[0],
                                },
                                yAxis: target1Arr[target1Len - 1],
                                xAxis: todayDate,
                                itemStyle: {
                                    borderColor: colorData[0],
                                    shadowColor: colorData[0],
                                    shadowBlur: 1,
                                },
                            }
                        ]
                    },
                    data: target1Arr,
                    itemStyle: {
                        normal: {
                            color: colorData[0],
                            borderColor: "#03399f",
                            borderWidth: 2
                        }
                    },
                    lineStyle: {
                        normal: {
                            width: 2,
                            color: colorData[0],
                        }
                    },
                }, {
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    markLine: {
                        symbol: "none",
                        label: {
                            show: false,
                        },
                        lineStyle: {
                            type: "dashed",
                            color: '#6087CF',
                            width: 1
                        },
                        data: [{
                            xAxis: todayDate
                        }]
                    }
                }, {
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    markPoint: {
                        symbol: "circle",
                        symbolSize: 6,
                        itemStyle: {
                            color: '#ffffff',
                            borderWidth: 1,
                        },
                        data: [

                            {
                                value: target2Arr[target2Len - 1],
                                label: {
                                    position: data2Position,
                                    color: colorData[1],
                                },
                                yAxis: target2Arr[target2Len - 1],
                                xAxis: todayDate,
                                itemStyle: {
                                    borderColor: colorData[1],
                                    shadowColor: colorData[1],
                                    shadowBlur: 1,
                                },
                            },
                        ]
                    },

                    data: target2Arr,
                    name: labelData[1],
                    itemStyle: {
                        normal: {
                            color: colorData[1],
                            borderColor: "#03399f",
                            borderWidth: 2
                        }
                    },
                    lineStyle: {
                        normal: {
                            type: 'dashed',
                            width: 2,
                            color: colorData[1],
                        }
                    },
                }],
            };
            this.chart.setOption(option);
        },

    }
}
</script>

<style lang="scss" scoped>
.curve_chart {
    padding: 20px 16px;
    background-color: #FFFFFF;

    &.noLogin {
        padding: 0;
    }

    .content {
        line-height: 20px;
        margin: 12px auto 28px;
    }

    .chartBox {
        height: 300px;
    }
}

.iconBox {
    display: inline-block;
    text-indent: 0;
    padding-top: 3px;
}

.isWebPositive {
    span {
        display: inline-block;
        font-size: 14px;
        line-height: 14px;

        &:nth-child(n + 2) {
            padding-left: 6px;
            border-left: 1px solid #979797;
            margin-left: 6px;
        }
    }
}

.noLoginBg {
    width: 100%;
    height: 429px;
    background-size: 100% 100%;
    position: relative;

    span {
        display: inline-block;
        height: 16px;
        position: absolute;
        top: 57px;

        &:nth-child(1) {
            width: 56px;
            left: 18px;
        }

        &:nth-child(2) {
            width: 70px;
            left: 87px;
        }

        &:nth-child(3) {
            width: 84px;
            left: 170px;
        }

        &:nth-child(4) {
            width: 84px;
            left: 267px;
        }
    }
}
</style>